// extracted by mini-css-extract-plugin
module.exports = {"section":"section_3jkHI","edit":"edit_3g_Gk","edit-input":"edit-input_287nG"};